package com.dotdrives.model

import kotlinx.serialization.Serializable

@Serializable
data class OrgSummary(
    val id: String,
    val name: String,
    val kind: String,
    val role: String = "member",
    val fiscalStartMonth: Int = 1,
    val fiscalStartDay: Int = 1,
    val readOnly: Boolean = false,
    val supportSession: AdminSupportSession? = null,
)

data class OrgMember(
    val userId: String,
    val displayName: String,
    val role: String,
    val deactivatedAt: String? = null,
)
